// @ts-nocheck
class WIfooteraccor extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
       this.toggleAccor(); 
    }

    toggleAccor() {
        let accorOpner = this.querySelector('h5');
        accorOpner.addEventListener('click', ()=>{
            let accorContent = accorOpner.nextElementSibling;
            let currentMaxHeight = window.getComputedStyle(accorContent).getPropertyValue('max-height');

            if(currentMaxHeight == "0px"){
                accorContent.style.maxHeight = accorContent.scrollHeight + "px";
                accorOpner.querySelector('.WI_move').style.transform = 'rotate(90deg)';
            }else{
                accorContent.style.maxHeight = "0px";
                accorOpner.querySelector('.WI_move').style.transform = 'rotate(0deg)';
            }
        });
    }
}

customElements.define('wi-footer-accor', WIfooteraccor);